import NotePanel, { Props } from "../NotePanel/NotePanelBase/NotePanel";

interface EditProps extends Omit<Props, "mode"> {
  note: any;
}

export default function EditNotePanel({ note, ...props }: EditProps) {
  return (
    <NotePanel
      mode="edit"
      noteId={note.id}
      initialSubject={note.title}
      initialMessage={note.note}
      initialCategoryName={note.categoryName}
      {...props}
    />
  );
}
